import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UpdateTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Update Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Kamera Modell', descriptionColumn: 'Zeigt die Modellnummer Ihrer Kamera - Für mehr Informationen über Ihr Kamera Modell schauen Sie sich unsere vollständiges Portfolio an.' },
        { actionColumn: 'Firmware Version', descriptionColumn: 'Version des Betriebssystems Ihrer Kamera.' },
        { actionColumn: 'WebUI Version', descriptionColumn: 'Version der Weboberfläche Ihrer Kamera.' },
        { actionColumn: 'Software ist auf dem neuesten Stand', descriptionColumn: 'Sie bekommen einen Link angezeigt, wenn eine neue Version verfügbar ist. Bitte beachten Sie, dass Sie die update.pkg Datei entpacken müssen, bevor Sie die Datei auf Ihre Kamera hochladen!' },
        { actionColumn: 'Durchsuchen', descriptionColumn: 'Klicken Sie hier um nach der update.pkg Datei zu browsen und zu bestätigen.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UpdateTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UpdateTable)